import React, { useState, useEffect, useMemo } from 'react';
import {
	getItemsPerPage,
	paginateData,
	isPagingNeeded
} from '../../utils/pagination';
import { usePaginationContext } from '../../contexts/PaginationContext';
import PaginationButton from './PaginationButton';

const Pagination = () => {
	const {
		totalCount,
		allData,
		onPageChange,
		resetTriggers = []
	} = usePaginationContext();
	const [pageStart, setPageStart] = useState(0);
	const itemsPerPage = getItemsPerPage();

	const paging = {
		pageStart,
		pageSize: itemsPerPage,
		totalCount
	};

	const paginatedData = useMemo(
		() => paginateData(allData || [], pageStart, itemsPerPage),
		[allData, pageStart, itemsPerPage]
	);

	const currentPage = Math.floor(pageStart / itemsPerPage) + 1;

	// Reset pagination when search criteria change
	useEffect(() => {
		setPageStart(0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, resetTriggers);

	useEffect(() => {
		if (onPageChange) {
			onPageChange({
				paginatedData,
				currentPage
			});
		}
	}, [
		pageStart,
		totalCount,
		allData,
		onPageChange,
		paginatedData,
		currentPage
	]);

	const handlePageChange = (newPageStart) => {
		setPageStart(newPageStart);
	};

	if (!isPagingNeeded(paging)) {
		return null;
	}

	return (
		<nav aria-label="Page navigation">
			<ul className="pagination">
				<PaginationButton
					direction="previous"
					paging={paging}
					onPageChange={handlePageChange}
				/>
				<PaginationButton
					direction="next"
					paging={paging}
					onPageChange={handlePageChange}
				/>
			</ul>
		</nav>
	);
};

export default Pagination;
